import React from 'react';
import { connect } from 'react-redux';
import { Table, TableRow, TableHeaderCell } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';

import { selectIsWeedSprayWorksheet } from '../../../../../../selectors';

interface OwnProps {}

interface ConnectedProps {
    isWeedSpray: ReturnType<typeof selectIsWeedSprayWorksheet>;
}

type Props = OwnProps & ConnectedProps;

export class PrintSprayWorksheetCalibrationTableHeader extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { isWeedSpray } = this.props;

        return (
            <Table.Header>
                <TableRow>
                    <TableHeaderCell>Appl. Rate</TableHeaderCell>
                    <TableHeaderCell>Row width (min)</TableHeaderCell>
                    <TableHeaderCell>Row width (max)</TableHeaderCell>
                    {isWeedSpray ? (
                        <TableHeaderCell>Swath width</TableHeaderCell>
                    ) : null}
                    <TableHeaderCell>Gear</TableHeaderCell>
                    <TableHeaderCell>Speed</TableHeaderCell>
                    <TableHeaderCell>Pressure</TableHeaderCell>
                    <TableHeaderCell>Engine RPM</TableHeaderCell>
                    {isWeedSpray ? (
                        <TableHeaderCell>Nozzles/Side</TableHeaderCell>
                    ) : (
                        <TableHeaderCell>Fan Speed</TableHeaderCell>
                    )}
                </TableRow>
            </Table.Header>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isWeedSpray: selectIsWeedSprayWorksheet
});

export default connect(mapStateToProps)(
    PrintSprayWorksheetCalibrationTableHeader
);
